import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import PODetailMaterialScreen from "./PODetailMaterialScreen";
import PODetailServiceScreen from "./PODetailServiceScreen";
import {
  MATERIAL_CONSUMABLE_CODES,
  SERVICE_TOOLS_CODES,
} from "./poDetailShared";

const PODetailScreen = () => {
  const location = useLocation();
  const code = location.state?.purchaseOrderType?.code;

  if (MATERIAL_CONSUMABLE_CODES.includes(code)) {
    return <PODetailMaterialScreen />;
  }

  if (SERVICE_TOOLS_CODES.includes(code)) {
    return <PODetailServiceScreen />;
  }

  return (
    <DashboardLayout>
      <Box p={4}>
        <Typography>
          Tipo de orden de compra no reconocido. Regrese e intente de nuevo.
        </Typography>
      </Box>
    </DashboardLayout>
  );
};

export default React.memo(PODetailScreen);
